import React, { useState, useEffect } from "react";
import FilterByForDashboard from "../FilterByForDashboard";
import OverallSatisfaction from "./experienceComponents/OverallSatisfaction";
// import RepeatPurchaseIntent from "./experienceComponents/RepeatPurchaseIntent";
// import PerformanceVsExpectations from "./experienceComponents/PerformanceVsExpectations";
// import ValueForMoney from "./experienceComponents/ValueForMoney";
// import Uniqueness from "./experienceComponents/Uniqueness";
// import Likes from "./experienceComponents/Likes";
// import Dislikes from "./experienceComponents/Dislikes";
import { useGlobalContext } from "../../../context/GlobalContext";
import { useSelector } from "react-redux";
import {
  getBrandPreferenceChartData,
  getOverAllSatisfactionChartData,
} from "../../../services/dashboard/experience";
import BrandPreference from "./experienceComponents/BrandPreference";
import { validateCompareObjectValues } from "../../../utils/filterBy/filterBy";
import {
  COMMON_PAGE_BOTTOM_TEXT,
  SURVEY_BASE_SIZE_MID_VALUE,
  SURVEY_BASE_SIZE_MIN_VALUE,
} from "../../../utils/constants";
import ExperienceCategoryXmot from "./experienceComponents/ExperienceCategoryXmot";

const Experience = (props) => {
  const {
    productType = "",
    selectedFilters,
    setSelectedFilters,
    isFilterByApplied,
    setIsFilterByApplied,
    selectedFilterValues,
    setSelectedFilterValues,
  } = props;
  const {
    device,
    deviceCode,
    category,
    product_id,
    showSidebar,
    mappedCategory,
    project_id,
    isCustomRecruitCategory,
  } = useGlobalContext();
  const [loading, setLoading] = useState(false);
  const [brandLoading, setBrandLoading] = useState(false);
  const [OverallLoading, setOverallLoading] = useState(false);
  const [activeOption, setActiveOption] = useState("FILTERBY");
  const { question_id } = useSelector(
    (state) => state.dashboard.occasionsListData,
  );
  const { token, user } = useSelector((state) => state.auth);
  const { filter_week } = useSelector((state) => state.dateRange);
  const { hideFilter: isFilterHide } = useSelector((state) => state.dashboard);
  const [overAllSatisfactionChartData, setOverAllSatisfactionChartData] =
    useState({});
  const [overAllSatisfactionChartQues, setOverAllSatisfactionChartQues] =
    useState("");
  const [brandPreferenceChartData, setBrandPreferenceChartData] = useState({});
  const [brandPreNeutralChartData, setBrandPreNeutralChartData] = useState({});
  const [brandPreOkayChartData, setBrandPreOkayChartData] = useState({});
  const [brandPreferenceChartQues, setBrandPreferenceChartQues] = useState("");
  // const [selectedFilters, setSelectedFilters] = useState({});
  const [selectedBrands, setSelectedBrands] = useState([]);
  const [selectedGenders, setSelectedGenders] = useState([]);
  const [selectedOccasions, setSelectedOccasions] = useState([]);
  const [selectedHouseHoldAge, setSelectedHouseHoldAge] = useState([]);
  const [selectedHouseHoldIncome, setSelectedHouseHoldIncome] = useState([]);
  const [selectedHouseHoldSize, setSelectedHouseHoldSize] = useState([]);
  const [selectedHouseHoldChildren, setSelectedHouseHoldChildren] = useState(
    [],
  );
  const [selectedHouseHoldRaceEthnicity, setSelectedHouseHoldRaceEthnicity] =
    useState([]);
  const [activeDataTypeButton, setActiveDataTypeButton] = useState("Single");
  const [activeDataTypePreferenceBtn, setActiveDataTypePreferenceBtn] =
    useState("Single");
  const [selectedForms, setSelectedForms] = useState([]);
  const [selectedDayPart, setSelectedDayPart] = useState([]);
  const [selectedWeekPart, setSelectedWeekPart] = useState([]);
  const [selectedTimeOfDay, setSelectedTimeOfDay] = useState([]);
  const [filterByApply, setFilterByApply] = useState(false);
  // const [isFilterHide, setIsFilterHide] = useState(false);

  const getSelectedCategoriesString = () => {
    const categories = [];
    if (selectedHouseHoldAge.length > 0) categories.push("age");
    if (selectedHouseHoldIncome.length > 0) categories.push("income");
    if (selectedHouseHoldSize.length > 0) categories.push("size");
    if (selectedHouseHoldChildren.length > 0) categories.push("children");
    if (selectedHouseHoldRaceEthnicity.length > 0)
      categories.push("raceEthnicity");
    return categories.join("|");
  };

  const getRequestBody = () => {
    return {
      compare_with: props?.selectedComparitionBy,
      compare_by: props?.compareBy,
      filter_form:
        props?.selectedComparitionBy !== "form" || activeOption === "FILTERBY"
          ? selectedForms.join("|")
          : "",
      filter_brand:
        props?.selectedComparitionBy !== "brand" || activeOption === "FILTERBY"
          ? selectedBrands.join("|")
          : "",
      filter_household: isFilterByApplied
        ? selectedFilterValues?.houseHold
          ? Object.values(selectedFilterValues?.houseHold)
              .flat()
              .map((item) => item.uniques.trim())
              .filter((value) => value !== "All") // Remove "All" if present
              .join("|")
          : ""
        : "",
      filter_household_type:
        activeOption === "FILTERBY" ? getSelectedCategoriesString() : "",
      filter_occasion:
        activeOption === "FILTERBY" ? selectedOccasions.join("|") : "",
      occasion_question_id: question_id !== "" ? parseInt(question_id) : 0,
      product_id: parseInt(product_id),
      product_type: productType,
      project_id: parseInt(project_id),
      question_id: 0,
      section_type:
        props?.chooseComparison && validateCompareObjectValues(props?.compareBy)
          ? "compare"
          : "filter",
      mapped_category: mappedCategory,
      filter_week: filter_week,
    };
  };

  const fetchOverAllSatisfactionChartData = () => {
    setLoading(true);
    setOverallLoading(true);
    const requestBody = {
      ...getRequestBody(),
      box_type: activeDataTypeButton,
    };

    getOverAllSatisfactionChartData(requestBody, token)
      .then((overallSatisfactionResponse) => {
        setOverAllSatisfactionChartData(
          overallSatisfactionResponse.data.graphs,
        );
        setOverAllSatisfactionChartQues(
          overallSatisfactionResponse.data.question,
        );
      })
      .catch((error) => {
        console.error("Error fetching chart data:", error);
      })
      .finally(() => {
        setLoading(false);
        setOverallLoading(false);
      });
  };

  const fetchBrandPreferenceChartData = () => {
    setLoading(true);
    setBrandLoading(true);
    const requestBody = {
      ...getRequestBody(),
    };

    getBrandPreferenceChartData({ ...requestBody, box_type: "Charts" }, token)
      .then((brandPreferenceChartRes) => {
        setBrandPreferenceChartData(brandPreferenceChartRes.data?.graphs_dis);
        setBrandPreferenceChartQues(brandPreferenceChartRes.data.question);
        setBrandPreNeutralChartData(brandPreferenceChartRes.data?.graphs_neut);
        setBrandPreOkayChartData(brandPreferenceChartRes.data?.graphs_ok);
      })
      .catch((error) => {
        console.error("Error fetching chart data:", error);
      })
      .finally(() => {
        setLoading(false);
        setBrandLoading(false);
      });
  };

  useEffect(() => {
    if (productType !== "" && !isCustomRecruitCategory) {
      fetchOverAllSatisfactionChartData();
    }
  }, [
    productType,
    filterByApply,
    props?.apply,
    activeDataTypeButton,
    filter_week,
  ]);

  useEffect(() => {
    if (productType !== "" && !isCustomRecruitCategory) {
      fetchBrandPreferenceChartData();
    }
  }, [
    productType,
    filterByApply,
    props?.apply,
    activeDataTypePreferenceBtn,
    filter_week,
  ]);

  useEffect(() => {
    if (props?.selectedComparitionBy === "brand") {
      setSelectedBrands([]);
    }
    if (props?.selectedComparitionBy === "form") {
      setSelectedForms([]);
    }
    if (props?.selectedComparitionBy === "household") {
      setSelectedFilters({});
    }
  }, [props?.selectedComparitionBy]);

  const handleReset = () => {
    setSelectedDayPart([]);
    setSelectedWeekPart([]);
    setSelectedBrands([]);
    setSelectedOccasions([]);
    setSelectedFilters({});
    setSelectedForms([]);
    setFilterByApply(!filterByApply);
    setIsFilterByApplied(false);
    setSelectedFilterValues({});
  };

  const handleFilterApply = () => {
    setSelectedFilterValues((prevProp) => {
      return {
        ...prevProp,
        houseHold: selectedFilters,
      };
    });
  };

  return (
    <>
      {isCustomRecruitCategory ? (
        <ExperienceCategoryXmot token={token} study_id={project_id} />
      ) : (
        <div className="row">
          {/* Filter By Component */}
          {/* {user?.type === "superadmin" ? ( */}
          <FilterByForDashboard
            loading={loading}
            setLoading={setLoading}
            device={device}
            deviceCode={deviceCode}
            category={category}
            product_id={product_id}
            productType={productType}
            activeOption={activeOption}
            setActiveOption={setActiveOption}
            selectedForms={selectedForms}
            setSelectedForms={setSelectedForms}
            selectedBrands={selectedBrands}
            setSelectedBrands={setSelectedBrands}
            selectedGenders={selectedGenders}
            setSelectedGenders={setSelectedGenders}
            selectedOccasions={selectedOccasions}
            setSelectedOccasions={setSelectedOccasions}
            selectedHouseHoldAge={selectedHouseHoldAge}
            setSelectedHouseHoldAge={setSelectedHouseHoldAge}
            selectedHouseHoldIncome={selectedHouseHoldIncome}
            setSelectedHouseHoldIncome={setSelectedHouseHoldIncome}
            selectedHouseHoldSize={selectedHouseHoldSize}
            setSelectedHouseHoldSize={setSelectedHouseHoldSize}
            selectedHouseHoldChildren={selectedHouseHoldChildren}
            setSelectedHouseHoldChildren={setSelectedHouseHoldChildren}
            selectedHouseHoldRaceEthnicity={selectedHouseHoldRaceEthnicity}
            setSelectedHouseHoldRaceEthnicity={
              setSelectedHouseHoldRaceEthnicity
            }
            selectedDayPart={selectedDayPart}
            setSelectedDayPart={setSelectedDayPart}
            selectedWeekPart={selectedWeekPart}
            setSelectedWeekPart={setSelectedWeekPart}
            selectedTimeOfDay={selectedTimeOfDay}
            setSelectedTimeOfDay={setSelectedTimeOfDay}
            apply={filterByApply}
            setApply={(filterByflagValue) => {
              setFilterByApply(filterByflagValue);
              setIsFilterByApplied(true);
              handleFilterApply();
            }}
            isCompareByClicked={props?.isCompareByClicked}
            setIsCompareByClicked={props?.setIsCompareByClicked}
            setSelectedFilters={setSelectedFilters}
            selectedFilters={selectedFilters}
            handleReset={handleReset}
            // setIsFilterHide={(toggle) => setIsFilterHide(toggle)}
            selectedComparitionBy={props?.selectedComparitionBy}
            mappedCategory={mappedCategory}
          />
          {/* ) : (
            ""
          )} */}
          <div
            className={isFilterHide ? `col-12` : `col-9`}
            style={{ padding: "0px 5%" }}
          >
            <OverallSatisfaction
              isFilterHide={isFilterHide}
              showSidebar={showSidebar}
              overAllSatisfactionChartData={overAllSatisfactionChartData}
              loading={loading && OverallLoading}
              activeDataTypeButton={activeDataTypeButton}
              setActiveDataTypeButton={setActiveDataTypeButton}
              chartQuestion={overAllSatisfactionChartQues}
            />

            <BrandPreference
              isFilterHide={isFilterHide}
              showSidebar={showSidebar}
              brandPreferenceChartData={brandPreferenceChartData}
              brandPreNeutralChartData={brandPreNeutralChartData}
              brandPreOkayChartData={brandPreOkayChartData}
              loading={loading && brandLoading}
              activeDataTypeButton={activeDataTypePreferenceBtn}
              setActiveDataTypeButton={setActiveDataTypePreferenceBtn}
              chartQuestion={brandPreferenceChartQues}
            />
            {/* <RepeatPurchaseIntent
              isFilterHide={isFilterHide} 
              showSidebar={showSidebar}
            />
            <PerformanceVsExpectations
              isFilterHide={isFilterHide}
              showSidebar={showSidebar}
            />
            <ValueForMoney 
              isFilterHide={isFilterHide} 
              showSidebar={showSidebar}
            />
            <Uniqueness
              isFilterHide={isFilterHide} 
              showSidebar={showSidebar} 
            />
            <Likes
              isFilterHide={isFilterHide} 
              showSidebar={showSidebar} 
            />
            <Dislikes
              isFilterHide={isFilterHide} 
              showSidebar={showSidebar} 
            /> */}
            <div
              className="text-light-gray text-start my-3"
              style={{
                fontSize: "12px",
                fontWeight: "bold",
              }}
            >
              {/* {COMMON_PAGE_BOTTOM_TEXT} */}
              <div>{`*Low sample (n<${SURVEY_BASE_SIZE_MIN_VALUE} survey responses)`}</div>
              <div>{`^Directional Use Only (n=${SURVEY_BASE_SIZE_MID_VALUE} survey responses)`}</div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default Experience;
